module.exports = __webpack_public_path__ + "static/media/recurNaran.b30a157c.png";